import { Flex, type FlexProps } from '@chakra-ui/react';
import { type HTMLMotionProps, motion } from 'framer-motion';
import type { ComponentType } from 'react';

export type MotionFlexProps = Omit<
  FlexProps,
  keyof HTMLMotionProps<'div'> | 'transition'
> &
  HTMLMotionProps<'div'>;

export const MotionFlex = motion.create(Flex) as ComponentType<MotionFlexProps>;
